import React, { useState, useEffect } from 'react';
import { FaTimes, FaFileInvoice } from 'react-icons/fa';

const TransactionDocumentModal = ({ refType, refId, onClose }) => {
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Mock fetch based on reference type (In production this calls actual Invoice APIs)
        setTimeout(() => {
            setDoc({
                title: refType === 'PURCHASE_INVOICE' ? 'Purchase Invoice' : 
                       refType === 'SALES_INVOICE' ? 'Sales Receipt' : 'System Transaction',
                refId: refId,
                date: new Date().toLocaleString(),
                details: 'This is a traced original document for this transaction. The backend API will return the full JSON of the original invoice/receipt based on Reference Type and ID.'
            });
            setLoading(false);
        }, 800);
    }, [refId, refType]);

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '16px', width: '600px', maxWidth: '95%', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ padding: '24px 32px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#F8F9FD', borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ background: '#e0e7ff', padding: '10px', borderRadius: '10px', color: '#4f46e5' }}>
                            <FaFileInvoice size={20} />
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '18px', color: '#1e293b' }}>Transaction Source</h3>
                            <p style={{ margin: 0, fontSize: '13px', color: '#64748b', textTransform: 'uppercase' }}>{refType}</p>
                        </div>
                    </div>
                    <button onClick={onClose} style={{ background: '#e2e8f0', border: 'none', cursor: 'pointer', fontSize: '14px', color: '#64748b', padding: '8px', borderRadius: '50%' }}>
                        <FaTimes />
                    </button>
                </div>
                <div style={{ padding: '32px', flex: 1, backgroundColor: '#ffffff' }}>
                    {loading ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
                            <div className="loader"></div>
                            <p style={{ color: '#94a3b8', marginTop: '12px', fontSize: '14px' }}>Loading original document...</p>
                        </div>
                    ) : (
                        <div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '24px' }}>
                                <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #f1f5f9' }}>
                                    <p style={{ margin: '0 0 4px 0', fontSize: '12px', color: '#64748b', textTransform: 'uppercase', fontWeight: '600' }}>Document ID</p>
                                    <h4 style={{ margin: 0, fontSize: '16px', color: '#334155' }}>{doc?.refId}</h4>
                                </div>
                                <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #f1f5f9' }}>
                                    <p style={{ margin: '0 0 4px 0', fontSize: '12px', color: '#64748b', textTransform: 'uppercase', fontWeight: '600' }}>Type</p>
                                    <h4 style={{ margin: 0, fontSize: '16px', color: '#334155' }}>{doc?.title}</h4>
                                </div>
                            </div>
                            
                            <div style={{ borderLeft: '3px solid #3b82f6', paddingLeft: '16px' }}>
                                <p style={{ margin: '0 0 8px 0', fontSize: '15px', color: '#475569', lineHeight: '1.6' }}>
                                    {doc?.details}
                                </p>
                                <p style={{ margin: 0, fontSize: '13px', color: '#94a3b8' }}>Processed at {doc?.date}</p>
                            </div>
                        </div>
                    )}
                </div>
                <div style={{ padding: '16px 32px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', background: '#f8fafc', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                    <button onClick={onClose} style={{ background: '#06D6A0', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
                        Close Document
                    </button>
                </div>
            </div>
            <style>{`
                .loader { width: 30px; height: 30px; border: 3px solid #e2e8f0; border-top: 3px solid #06D6A0; border-radius: 50%; animation: spin 1s linear infinite; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
};

export default TransactionDocumentModal;
